import { I18nComponente } from "@/types/gerais"

export const TRecuperacaoDeSenhai18n: I18nComponente = {
  "pt-BR": {
    insiraUmEmail: "Insira um email",
    insiraUmEmailValido: "Insira uma email válido",
    recuperacaoDeSenha: "recuperação de senha",
    qualSeuEmailDeAcesso: "qual seu e-mail de acesso?",
    confirmeSeuEmail: "Confira seu e-mail para mais informações sobre como recuperar sua senha.",
    emailDeRecuperacaoDeSenhaEnviado: "E-mail de recuperação de senha enviado.",
    erroAoEnviarEmailDeRecuperacaoDeSenha: "Erro ao enviar e-mail de recuperação de senha.",
    voltar: "voltar",
    continuar: "continuar"
  },
  "es-CO": {
    insiraUmEmail: "Ingrese un correo electrónico",
    insiraUmEmailValido: "Ingrese un correo electrónico válido",
    recuperacaoDeSenha: "recuperación de contraseña",
    qualSeuEmailDeAcesso: "¿Cuál es tu correo electrónico de acceso?",
    confirmeSeuEmail: "Confirme su correo electrónico para obtener más información sobre cómo recuperar su contraseña.",
    emailDeRecuperacaoDeSenhaEnviado: "Correo electrónico de recuperación de contraseña enviado.",
    erroAoEnviarEmailDeRecuperacaoDeSenha: "Error al enviar el correo electrónico de recuperación de contraseña.",
    voltar: "volver",
    continuar: "continuar"
  }
}
